// Classificazione SLA lato client (specchio di backend/utils/supportSla.js).

export interface TicketSla {
  firstResponseDueAt?: string | null;
  resolutionDueAt?: string | null;
  pausedAt?: string | null;
  pausedMs?: number;
}

export interface SlaTicketLike {
  status: string;
  createdAt: string;
  firstResponseAt?: string | null;
  sla?: TicketSla | null;
}

export type SlaLevel = 'ok' | 'warning' | 'breach' | 'paused';

export interface SlaInfo {
  target: 'firstResponse' | 'resolution';
  level: SlaLevel;
  dueAt: Date;
  remainingMs: number;
}

export const WARNING_FRACTION = 0.25;

export function classifySla(ticket: SlaTicketLike, now: Date): SlaInfo | null {
  if (!ticket || !ticket.sla) return null;
  if (ticket.status === 'risolto' || ticket.status === 'chiuso') return null;
  const nowMs = now.getTime();
  const createdMs = new Date(ticket.createdAt).getTime();
  const sla = ticket.sla;

  if (!ticket.firstResponseAt && sla.firstResponseDueAt) {
    const dueMs = new Date(sla.firstResponseDueAt).getTime();
    const remainingMs = dueMs - nowMs;
    const budgetMs = dueMs - createdMs;
    return {
      target: 'firstResponse', dueAt: new Date(dueMs), remainingMs,
      level: remainingMs < 0 ? 'breach' : (budgetMs > 0 && remainingMs < budgetMs * WARNING_FRACTION ? 'warning' : 'ok')
    };
  }

  if (!sla.resolutionDueAt) return null;
  const dueMs = new Date(sla.resolutionDueAt).getTime();
  if (sla.pausedAt) {
    return { target: 'resolution', dueAt: new Date(dueMs), remainingMs: dueMs - new Date(sla.pausedAt).getTime(), level: 'paused' };
  }
  const remainingMs = dueMs - nowMs;
  const budgetMs = dueMs - createdMs - (sla.pausedMs || 0);
  return {
    target: 'resolution', dueAt: new Date(dueMs), remainingMs,
    level: remainingMs < 0 ? 'breach' : (budgetMs > 0 && remainingMs < budgetMs * WARNING_FRACTION ? 'warning' : 'ok')
  };
}
